// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a0ba7f6a","703":"17947396","845":"a47a2828"}[chunkId] + ".chunk.js";
};